import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IPatientUnlisted, ISearchPatientsUnlisted } from "../models/IPatientUnlisted";
import { IAdditionalAssignmentBaseArea, ISearchAdditionalAssignmentBaseAreas } from "../models/IAdditionalAssignment";
import { objectToQueryString } from "../helpers/ApiHelper";
import { ICareProvider } from "../models/ICareProvider";


export class AdditionalAssignmentApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    hasAdditionalAssignments(success: (data: boolean) => void, error?: (message: string) => void) {
        this.get<boolean>(`${Utils.LIB_API_BASE_URL}/additionalAssignments/hasAdditionalAssignments`, success, error);
    };

    getUmbrellaOrganisations(success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/additionalAssignments/umbrellaOrganisations`, success, error, final);
    }

    getUmbrellaCareProviders(umbrellaOrganisationId: number, success: (careProviders: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/additionalAssignments/careProviders/${umbrellaOrganisationId}`, success, error, final);
    }

    getUnlistedPatients(searchParams: ISearchPatientsUnlisted, success: (data: IPaginatedResponse<IPatientUnlisted[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IPatientUnlisted[]>(`${Utils.LIB_API_BASE_URL}/additionalAssignments/unlistedPatients?${queryString}`, success, error, final);
    }

    getUnlistedPatientsAsExcel(searchParams: ISearchPatientsUnlisted, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/additionalAssignments/unlistedPatients?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getAdditionalAssignmentBaseAreas(searchParams: ISearchAdditionalAssignmentBaseAreas, success: (data: IPaginatedResponse<IAdditionalAssignmentBaseArea[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IAdditionalAssignmentBaseArea[]>(`${Utils.LIB_API_BASE_URL}/additionalAssignments/additionalAssignmentBaseAreas?${queryString}`, success, error, final);
    }

    getAdditionalAssignmentBaseAreasAsExcel(searchParams: ISearchAdditionalAssignmentBaseAreas, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/additionalAssignments/additionalAssignmentBaseAreas?${queryString}&exportToExcel=true`, fileName, success, error, final);
    }
}